import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { wrapStructure } from 'util/structure-module';

const moduleFn = () =>
    import('open-modules/zdf/structure/videovoting').then((m) => ({ structureModule: wrapStructure(m.VideoVotingStructure) }));

export default function VideoVotingInstanceLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<'/[siloKey]/videovoting/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'videovoting',
        instanceKey,
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
